import CoconeuseBioTemplate from "../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseEmma = () => (
  <CoconeuseBioTemplate
    name="Emmanuelle · Emma"
    subtitle="Vulnérabilité · Authenticité · Guidance · Harmonisation"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/wfrtnvi0_DSC07276.jpg"
    bioText={[
      "Emmanuelle, que beaucoup appellent simplement Emma, est enveloppée d'une douceur et d'une sensibilité profonde.",
      "Sa présence éclaire les espaces qu'elle traverse par une vulnérabilité assumée, transformatrice, et une authenticité qui invite naturellement à déposer les masques.",
      "Avec elle, chacun·e peut retrouver la simplicité d'être pleinement soi.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/9t96vnj3_DSC06753.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/97407cbd_DSC07265.jpg",
      "https://customer-assets.emergentagent.com/job_1ad292ee-d2b9-43b7-ad20-f1ecbd9288bb/artifacts/3nyqtezl_DSC07244.jpg",
    ]}
    expertise={["Vulnérabilité consciente", "Authenticité", "Guidance émotionnelle"]}
  />
);

export default CoconeuseEmma;
